/**
 * ver 0.1
 * author jack
 * created 18-12-10
 */
import React from 'react'
import axios from 'axios'

import LoginLayer from './loginLayer'
import DefaultLayer from 'common/container/layer/defaultLayer'

class ZzimLayer extends React.Component {
    constructor(props) {
        super(props)

        let { f_div, idx, selected } = props

        this.state = {
            componentMount: false,
            componentUpdate: true,
            f_div,
            idx,
            selected,
            zzimGroups: [],
            selectZzimGroup: 0,
            isLogin: true,
            showAddGroup: false,
            groupName: '',
            layerError: false,
            defaultLayer: 0,
        }

        this.apiUrl = process.env.REACT_APP_API_URL
        this.config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization',
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.componentUpdate
    }

    componentDidMount() {
        if (this.state.selected) {
            let _params = {
                f_div: this.state.f_div,
                idx: this.state.idx,
            }

            axios.post(this.apiUrl + '/front/v2/zzim/del', _params, this.config).then(res => {
                if (res.data.code === 200) {
                    this.onDefaultLayer(2)
                } else {
                    this.setState({ isLogin: false, componentMount: true, componentUpdate: true })
                }
            })
        } else {
            axios.get(this.apiUrl + '/front/v2/zzim/group', this.config).then(res => {
                if (res.data.code === 200) {
                    this.setState({
                        zzimGroups: res.data.result,
                        selectZzimGroup: res.data.result[0].gid_zzim,
                        componentUpdate: true,
                        componentMount: true,
                    })
                } else {
                    this.setState({ isLogin: false, componentMount: true, componentUpdate: true })
                }
            })
        }
    }

    componentDidUpdate(_prevProps, _prevState, _snapshot) {
        if (this.state.componentUpdate === true) {
            this.setState({ componentUpdate: false })
        }
    }

    onShowAddGroup() {
        this.setState({
            showAddGroup: !this.state.showAddGroup,
            groupName: '',
            componentUpdate: true,
        })
    }

    onAddGroup() {
        let groupName = this.state.groupName
        if (groupName === '') {
            this.setState({ layerError: true })
            return false
        }
        let _params = {
            f_div: 99,
            gname: groupName,
        }

        axios.post(this.apiUrl + '/front/v2/zzim/save', _params, this.config).then(res => {
            if (res.data.code === 200) {
                this.onDefaultLayer(3)
                this.setState({ zzimGroups: res.data.result, groupName: '', componentUpdate: true })
            } else {
                this.setState({ isLogin: false, componentUpdate: true })
            }
        })
    }

    onAddZzim() {
        let _params = {
            f_div: this.state.f_div,
            idx: this.state.idx,
            gid_zzim: this.state.selectZzimGroup,
        }

        axios.post(this.apiUrl + '/front/v2/zzim/save', _params, this.config).then(res => {
            if (res.data.code === 200) {
                this.onDefaultLayer(1)
            } else {
                this.setState({ isLogin: false, componentUpdate: true })
            }
        })
    }

    onSelectZzimGroup(e) {
        this.setState({ selectZzimGroup: parseInt(e.target.value, 10), componentUpdate: true })
    }

    groupName(e) {
        this.setState({ groupName: e.target.value, componentUpdate: true })
    }

    onDefaultLayer(t) {
        // t = (0 : 닫기, 1 : 찜하기, 2 : 찜삭제, 3 : 찜그룹 등록)
        if (t === undefined) {
            t = 0
            if (this.state.defaultLayer === 2) {
                this.props.onClose(false)
            } else if (this.state.defaultLayer === 1) {
                this.props.onClose(true)
            }
        }
        this.setState({ defaultLayer: t, componentMount: true, componentUpdate: true })
    }

    render() {
        if (this.state.componentMount === false) return false
        if (this.state.isLogin === false) return <LoginLayer onClose={() => this.props.onClose(this.state.selected)} />
        // console.log(this.state.showAddGroup);

        if (this.state.defaultLayer === 1) {
            return (
                <DefaultLayer onClose={() => this.onDefaultLayer()}>
                    해당 상품을 <font className="clrpont1">선택한 그룹에 저장</font>하였습니다.
                </DefaultLayer>
            )
        }
        if (this.state.defaultLayer === 2) {
            return (
                <DefaultLayer onClose={() => this.onDefaultLayer()}>
                    해당 상품이 <font className="clrpont1">찜하기에서 제외</font> 되었습니다.
                </DefaultLayer>
            )
        }
        if (this.state.defaultLayer === 3) {
            return (
                <DefaultLayer onClose={() => this.onDefaultLayer()}>
                    그룹이 <font className="clrpont1">추가</font> 되었습니다
                </DefaultLayer>
            )
        }
        if (this.state.selected) return false

        return (
            <table id="lyrPop">
                <tbody>
                    <tr>
                        <td className="">
                            <div className="PopMain zzimPop">
                                <strong className="popName">상품 찜하기</strong>
                                <b className="zzimB">선택한 상품을 그룹에 저장 합니다.</b>
                                <div className="zzGrpList">
                                    {this.state.zzimGroups.map((v, i) => {
                                        let radioId = 'zzimRadio_' + i
                                        let checked = this.state.selectZzimGroup === v.gid_zzim
                                        return (
                                            <div className="zzGrp" key={i}>
                                                <span className="zzLeft iradio">
                                                    <input
                                                        type="radio"
                                                        name={radioId}
                                                        id={radioId}
                                                        checked={checked}
                                                        onChange={e => this.onSelectZzimGroup(e)}
                                                        value={v.gid_zzim}
                                                    />
                                                    <label htmlFor={radioId}>{v.gname}</label>
                                                </span>
                                                <span className="zzRight zCnt">{v.cnt}</span>
                                            </div>
                                        )
                                    })}
                                    {this.state.showAddGroup && (
                                        <div className="zzGrp blind">
                                            <span className="zzLeft">
                                                <input
                                                    type="text"
                                                    className="zzimInp"
                                                    value={this.state.groupName}
                                                    onChange={e => this.groupName(e)}
                                                    placeholder="그룹명을 입력하세요."
                                                />
                                            </span>

                                            <span className="zzRight">
                                                <button className="styWBg" onClick={() => this.onAddGroup()}>
                                                    추가
                                                </button>
                                                <button
                                                    className="styNor icon-X_close"
                                                    onClick={() => this.onShowAddGroup()}
                                                />
                                            </span>
                                        </div>
                                    )}
                                    {this.state.layerError &&
                                        {
                                            /* <div><span>그룹명을 작성해 주세요</span></div> */
                                        }}
                                </div>
                                {!this.state.showAddGroup && (
                                    <div className="zzimGrpAdd">
                                        <button
                                            className="styWBg icon-add_circle"
                                            onClick={() => this.onShowAddGroup()}
                                        >
                                            그룹 추가하기
                                        </button>
                                    </div>
                                )}
                                <div className="zzImNoti">
                                    <p>ㆍ찜한 내역은 각 그룹별 최대 100개까지 저장</p>
                                    <p>ㆍ찜한 내역은 찜한 날짜로부터 180일 동안 저장</p>
                                </div>
                                <div className="popDefBtns">
                                    <button
                                        className="icon-X_close"
                                        onClick={() => this.props.onClose(this.state.selected)}
                                    />
                                    <button className="confBtn" onClick={() => this.props.onClose(this.state.selected)}>
                                        취소
                                    </button>
                                    <button className="confBtn styPBg" onClick={() => this.onAddZzim()}>
                                        확인
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }
}
export default ZzimLayer



// WEBPACK FOOTER //
// ./src/common/container/layer/zzimLayer.js